export const getFilteredContainerFollowUpVariables = () => ({
  input: {
    filters: {
      purchaseIncoterms: [],
      statuses: ['ALL_BOOKED', 'UNPLANNED', 'PC_BOOKED', 'LOADED', 'DELIVERED'],
      operationStatuses: ['CONFIRMED'],
    },
    orderBy: null,
    // pagination: {
    //   limit: 100,
    //   offset: 0,
    // },
    searchText: '',
    withPlannings: true,
  },
});
